import { Button, createStyles, FormControl, FormHelperText, IconButton, InputAdornment, makeStyles, TextField, Tooltip } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import { useCommentState, useDocumentData, useDocumentViewerApi, useLocalization, useViewerState } from "../../hooks/index.js";
import { PushPinIcon } from "./index.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row-reverse'
    },
    form: {
      width: '100%',
      display: 'flex'
    },
    activePin: {
      color: theme.palette.primary.light
    }
  });
});
/**
 * Represents a comment creator component
 */

export function CreateComment() {
  var _viewerState$rotation, _viewerState$rotation2;

  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState();
  const [createCommentValue, setCreateCommentValue] = useState('');
  const localization = useLocalization();
  const commentState = useCommentState();
  const viewerState = useViewerState();
  const api = useDocumentViewerApi();
  const {
    documentData
  } = useDocumentData();
  const pageRotation = ((_viewerState$rotation = viewerState.rotation) === null || _viewerState$rotation === void 0 ? void 0 : (_viewerState$rotation2 = _viewerState$rotation.find(rotation => rotation.pageNum === viewerState.activePage)) === null || _viewerState$rotation2 === void 0 ? void 0 : _viewerState$rotation2.degree) || 0;
  const createComment = useCallback(text => {
    if (!commentState.draft) {
      return;
    }

    try {
      api.commentActions.addPreviewComment({
        document: documentData,
        comment: { ...commentState.draft,
          text,
          page: commentState.draft.page
        },
        abortController: new AbortController()
      });
    } catch (error) {
      console.log(error);
    }
  }, [api.commentActions, commentState.draft, documentData]);
  const clearState = useCallback(() => {
    commentState.setDraft(undefined);
    viewerState.updateState({
      isPlacingCommentMarker: false,
      isCreateCommentActive: !viewerState.isCreateCommentActive
    });
    setCreateCommentValue('');
    setErrorMessage(undefined);
  }, [commentState, viewerState]);
  const validate = useCallback(() => {
    if (!createCommentValue) {
      return localization.inputRequiredError;
    }

    if (!commentState.draft) {
      return localization.markerRequiredError;
    }

    return undefined;
  }, [commentState.draft, createCommentValue, localization.inputRequiredError, localization.markerRequiredError]);
  const handleSubmit = useCallback(event => {
    event.preventDefault();
    const errorText = validate();

    if (errorText) {
      setErrorMessage(errorText);
      return;
    }

    createComment(createCommentValue);
    clearState();
  }, [clearState, createComment, createCommentValue, validate]);

  const handleOnChange = e => {
    setCreateCommentValue(e.target.value);
    setErrorMessage(undefined);
  };

  if (!viewerState.isCreateCommentActive) {
    return /*#__PURE__*/React.createElement(Button, {
      disabled: pageRotation !== 0,
      color: "primary",
      onClick: () => viewerState.updateState({
        isCreateCommentActive: !viewerState.isCreateCommentActive
      })
    }, localization.addComment);
  }

  return /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    error: !!errorMessage
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "comment-input",
    multiline: true,
    label: localization.commentInputPlaceholder,
    margin: "normal",
    variant: "filled",
    value: createCommentValue,
    onChange: handleOnChange,
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(Tooltip, {
        placement: "top",
        title: localization.markerTooltip
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "Toggle",
        onClick: () => viewerState.updateState({
          activeShapePlacing: 'none',
          isPlacingCommentMarker: !viewerState.isPlacingCommentMarker
        })
      }, /*#__PURE__*/React.createElement(PushPinIcon, {
        isPlacingMarker: viewerState.isPlacingCommentMarker,
        viewBox: "0 0 100 125"
      }))))
    }
  }), errorMessage ? /*#__PURE__*/React.createElement(FormHelperText, {
    id: "component-error-text"
  }, errorMessage) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    style: {
      alignSelf: 'flex-end'
    },
    fullWidth: false,
    color: "primary",
    variant: "text",
    type: "submit"
  }, localization.submit), /*#__PURE__*/React.createElement(Button, {
    onClick: clearState,
    style: {
      alignSelf: 'flex-end'
    },
    fullWidth: false,
    variant: "text"
  }, localization.cancelButton))));
}
//# sourceMappingURL=create-comment.js.map